






























import { Anagrafica } from "@/data/models/anagrafica.model";
import { AnagraficaService } from "@/data/services/anagrafica.service";
import { Component, Inject, Vue } from "vue-property-decorator";
import packageInfo from "../../../package.json";

@Component
export default class Consiglio extends Vue {
  @Inject("AnagraficaService") anagraficaService!: AnagraficaService;

  loading = true;
  base!: string;
  data!: Anagrafica[];

  loadData() {
    this.anagraficaService
      .getConsiglio()
      .then((result) => {
        this.data = result;
      })
      .finally(() => (this.loading = false));
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);

    this.loadData();
  }

  mounted() {
    const albourl = this.$el.parentElement?.getAttribute("data-albo") || "";
    this.base = "/" + albourl + "?profileid=";
  }
}
